import React, {useState} from "react";
import {ChooseButton} from "../choose-button/choose-button";
import styles from "./choose-list.module.css";

const ChooseList = ({ options, maxSelected, onChange}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [count, setCount] = useState(0);

  const handleOnClick = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((opt) => opt !== option));
      onChange(selectedOptions.filter((opt) => opt !== option))
      setCount(count - 1);
    } else {
      setSelectedOptions([...selectedOptions, option]);
      onChange([...selectedOptions, option]);
      setCount(count + 1);
    }
  };

  return (
    <div>
      <p className={styles.text}>Choose all that apply</p>
      <ul className={styles.list}>
        {options.map((option, idx) => (
          <li>
            <ChooseButton
                key={idx}
                onClick={(e) => handleOnClick(option.title)}
                isSelected={selectedOptions.includes(option.title)}
                disabled={count >= maxSelected && !selectedOptions.includes(option.title)}
                icon={option.icon}
            >
                {option.title}
                <div className={styles.check_icon}>
                    {selectedOptions.includes(option.title) &&
                        <svg viewBox="0 0 13 11">
                            <path d="M1 4.99844L5.62857 8.59844L11.8 1.39844" stroke="#213370"
                                  stroke-width="2.4"></path>
                        </svg>
                    }
                </div>
            </ChooseButton>
          </li>
        ))}
      </ul>
    </div>
  );
};

export {ChooseList};
